import PaginatedResponse from '../base/paginatedResponse'
import { ObjectType } from '@nestjs/graphql'
import { UserDto } from './model.dto'

@ObjectType()
export class UserPagedResultDto extends PaginatedResponse(UserDto) {
}
